import React, { useState, useEffect, useRef }from 'react';
import { Table, Form, Row, Col, Button } from 'react-bootstrap';
import { firestore } from '../../firebase';
import { Link } from 'react-router-dom';

export default function ResuppliesTable() {
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [resupplies, setResupplies] = useState([]);
    const [query, setQuery] = useState(firestore.collection('entradas').orderBy('fecha', 'desc').limit(20));
    const limit = useRef(20);
    const resuppliesLength = useRef(0);

    function getResupplies() {
        setLoading(true);
        query.onSnapshot(querySnapshot => {
            const items = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                let date = new Date(data.fecha.toDate());
                date = date.toLocaleDateString('es-ES', {
                    weekday: 'long', 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                });
                items.push({
                    id: doc.id,
                    fecha: date,
                    idProducto: data.producto.id,
                    codigo: data.producto.codigo,
                    descripcion: data.producto.descripcion,
                    cantidad: data.cantidad
                });
            })
            resuppliesLength.current = items.length;
            setResupplies(items);
            setLoading(false);
        })
    }

    function createQuery(e) {
        e.preventDefault();
        let newQuery = firestore.collection('entradas');

        if (search) {
            const searchArray = search.toLowerCase().split(' ')
            newQuery = newQuery.where('keywords', 'array-contains-any', searchArray)
        }

        setQuery(newQuery.orderBy('fecha', 'desc').limit(limit.current));
    }

    function handleScroll(e) {
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
        const windowBottom = window.innerHeight + window.pageYOffset;
        if (Math.ceil(windowBottom) >= docHeight && resuppliesLength.current === limit.current) {
            limit.current = limit.current+20;
            createQuery(e);
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getResupplies();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    return (
        <>
            <Form onSubmit={createQuery}>
                <Row className="m-2">
                    <Col className="my-1" xs={12} sm={8} md={9}>
                        <Form.Group controlId="searchBar">
                            <Form.Control 
                            type="text" 
                            placeholder="Buscar por producto..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col className="my-1" xs={12} sm={4} md={3}>
                        <Button type="submit">Buscar</Button>
                    </Col>
                </Row>
            </Form>
            <Table responsive striped bordered className='m-auto'>
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Código</th>
                        <th>Descripción</th>
                        <th>Cantidad</th>
                    </tr>
                </thead>
                <tbody>
                    {resupplies && 
                    resupplies.map(resupply => {
                        return (
                            <tr key={resupply.id}>
                                <td>{resupply.fecha}</td>
                                <td>
                                    <Link to={`/products/view_${resupply.idProducto}`}>
                                        {resupply.codigo}
                                    </Link>
                                </td>
                                <td>{resupply.descripcion}</td>
                                <td>{resupply.cantidad}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </Table>
            {loading && <h3 className="text-muted m-3">Cargando...</h3>}
        </>
    )
}